import { msg } from 'gt-react';
import { MonitorIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requirePermission,
} from '../route';

const AgentMonitorListingPage = lazyRouteComponent(
  () => import('./AgentMonitorListingPage'),
  'AgentMonitorListingPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/agent-monitor',
  staticData: {
    app: {
      nav: {
        label: msg('Agent Monitor', {
          context: 'sidebar nav label, Overview section',
        }),
        icon: <MonitorIcon className="h-4 w-4" weight="fill" />,
        group: 'Overview',
        order: 10, // Inbox is order 5 → Agent Monitor lands directly under it
        groupOrder: 1,
        pinned: true,
      },
      access: {
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.BackgroundAgent },
        ],
      },
    },
  },
  component: AgentMonitorListingPage,
  loader: () => ({
    crumb: msg('Agent Monitor', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.BackgroundAgent,
    });
  },
  validateSearch: z.object({}),
});
